import type { EffectCallback, DependencyList } from 'react';
import { useEffect, useRef } from 'react';

import useIsCollapsed from './use-is-collapsed.js';

/**
 * Custom hook that runs an effect only if the widget is expanded.
 */
function useExpandedEffect(
  callback: EffectCallback,
  dependencies: DependencyList,
) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const isCollapsed = useIsCollapsed();

  useEffect(
    () => {
      if (isCollapsed) {
        return;
      }

      return callbackRef.current();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isCollapsed, ...dependencies],
  );
}

export default useExpandedEffect;
